import { CheckCircle, XCircle, Info } from 'lucide-react';
import { useToastStore } from '../stores/toast';

export function Toaster(): JSX.Element {
  const { toasts, remove } = useToastStore();
  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`${toastClass(t.variant)} animate-in slide-in-from-right-5 fade-in duration-200 cursor-pointer`}
          onClick={() => remove(t.id)}
        >
          <div className="flex items-center gap-2">
            {getIcon(t.variant)}
            <div className="flex-1 min-w-0">
              {t.description && (
                <div className="text-sm font-medium leading-snug">{t.description}</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function getIcon(variant?: string): JSX.Element {
  if (variant === 'success') {
    return <CheckCircle className="w-4 h-4 text-emerald-600 flex-shrink-0" />;
  }
  if (variant === 'error') {
    return <XCircle className="w-4 h-4 text-red-600 flex-shrink-0" />;
  }
  return <Info className="w-4 h-4 text-blue-600 flex-shrink-0" />;
}

function toastClass(variant?: string): string {
  const base =
    'max-w-sm rounded-xl backdrop-blur-sm border px-3 py-2.5 transition-all hover:scale-[1.02]';
  if (variant === 'success')
    return `${base} bg-emerald-50/95 border-emerald-200 text-emerald-900`;
  if (variant === 'error')
    return `${base} bg-red-50/95 border-red-200 text-red-900`;
  return `${base} bg-white/95 border-slate-100 text-slate-900`;
}
